import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
export var RouterPath = /*#__PURE__*/function () {
  function RouterPath(path) {
    var isProtected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    _classCallCheck(this, RouterPath);

    this.path = path;
    this.isProtected = isProtected;
  }

  _createClass(RouterPath, [{
    key: "setPublicPath",
    value: function setPublicPath() {
      this.isProtected = false;
      return this;
    }
  }], [{
    key: "create",
    value: function create(path) {
      return new RouterPath(path);
    }
  }]);

  return RouterPath;
}();